import { ActionIcon, Box, Flex, Modal, Stack, Text, TextInput } from '@mantine/core';
import { IconPlus as AddIcon } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { Proceeding } from '@/module/Author/Proceeding';
import { ProceedingCard } from '@/module/Author/Proceeding/components/Card/ProceedingCard';

import { NoContentPlaceholder } from '@/core/components';

import { useFilterAvailable } from './hooks/useFilterAvailable';

interface CriteriaProceedingSelectAddModalProps {
  available: Proceeding[];
  selected: Proceeding[];

  close: () => void;
  onAdd: (proceeding: Proceeding) => void;
}

export function CriteriaProceedingSelectAddModal({
  available,
  selected,
  close,
  onAdd,
}: CriteriaProceedingSelectAddModalProps) {
  const { t } = useTranslation();
  const { searchProps, options } = useFilterAvailable({ available, selected });

  return (
    <Modal
      size="70vw"
      opened
      onClose={close}
      withCloseButton={false}
    >
      <Box p="sm">
        <Text
          fw="500"
          size="lg"
        >
          Proceedings
        </Text>
        <TextInput
          label="caută după titlu și autori"
          {...searchProps}
        />
      </Box>
      <Box
        mah="70vh"
        style={{ overflow: 'scroll' }}
      >
        {options.length === 0 && <NoContentPlaceholder title="Nu exista date" />}
        <Stack p="sm">
          {options.map(proceeding => (
            <Flex
              align="center"
              key={proceeding.id}
            >
              <ActionIcon
                mr="5px"
                onClick={() => onAdd(proceeding)}
                variant="filled"
                aria-label={t('button.add')}
              >
                <AddIcon
                  style={{ width: '70%', height: '70%' }}
                  stroke={1.5}
                />
              </ActionIcon>
              <ProceedingCard
                proceeding={proceeding}
                onClick={() => window.open(`/author/proceeding/${proceeding.id}`)}
              />
            </Flex>
          ))}
        </Stack>
      </Box>
    </Modal>
  );
}
